import { render } from "./UserRecipes.vue?vue&type=template&id=27f19148"
import script from "./UserRecipes.vue?vue&type=script&lang=js"
export * from "./UserRecipes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__